"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var decimal_char_to_simple_char_transform_1 = __importDefault(require("./decimal-char-to-simple-char-transform"));
var meta_to_char_class_transform_1 = __importDefault(require("./meta-to-char-class-transform"));
var simple_quantifier_to_range_quantifier_transform_1 = __importDefault(require("./simple-quantifier-to-range-quantifier-transform"));
var transforms = [
    decimal_char_to_simple_char_transform_1["default"],
    meta_to_char_class_transform_1["default"],
    simple_quantifier_to_range_quantifier_transform_1["default"],
];
exports["default"] = transforms;
//# sourceMappingURL=index.js.map